<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-3 pl-4 page-header" ref="pageHeader" style="padding-bottom: 0">
      <div class="row d-flex align-items-top" style="max-width: 1000px">
        <div class="col">
          <div>
            <h4>
              <b-icon class="me-2" icon="file-earmark"></b-icon>
              {{ order.Ordinal }} {{ order.DisplayName }}
            </h4>
            <div class="text-uppercase text-secondary"><small>Auftrag verwalten</small></div>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-inline">
            <!---------------------------------
                HEADER ACTION BUTTONS
            ---------------------------------->

            <b-button
              variant="light"
              @click="$router.push({ name: 'Hauptauftrag' })"
              size="sm"
              v-if="!$route.path.includes('/view') && ($root.$user.isPlaner || $root.$user.isAdmin)"
            >
              <b-icon icon="file-earmark" variant="dark" class="mr-1"></b-icon>
              Hauptauftrag
            </b-button>
            <b-button
              variant="light"
              class="ml-2"
              @click="$router.push('addendums')"
              size="sm"
              v-if="!$route.path.includes('/addendums') && ($root.$user.isPlaner || $root.$user.isAdmin)"
            >
              <b-icon icon="card-list" variant="dark" class="mr-1"></b-icon>
              Nachträge
            </b-button>

            <b-button
              variant="light"
              @click="$router.push({ name: 'Nachtrag erfassen' })"
              size="sm"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
              class="ml-2"
            >
              <b-icon icon="plus" variant="dark" class="mr-1"></b-icon>
              Nachtrag
            </b-button>
            <b-button
              variant="light"
              @click="$router.push({ name: 'Rechnungsübersicht' })"
              size="sm"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
              class="ml-2"
            >
              <svg
                width="18"
                height="18"
                fill="currentColor"
                class="bi-file-earmark me-2 b-icon bi"
                viewBox="0 0 16 16"
                version="1.1"
                id="svg4"
              >
                <path
                  d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                  id="path2"
                />
                <path
                  d="m 5.1218042,10.781435 h 0.7648806 c 0.2424881,2.088851 1.6218635,3.295535 3.7970601,3.295535 0.4475591,0 0.8397131,-0.04893 1.1937321,-0.133116 V 13.00844 c -0.348262,0.08563 -0.75193,0.122323 -1.1937321,0.122323 -1.5110531,0 -2.4860418,-0.862019 -2.7162975,-2.348608 H 9.8578749 V 10.114413 H 6.9185181 V 9.4409161 c 0,-0.07915 0,-0.1575811 0.00576,-0.2367316 H 9.8585939 V 8.5371627 H 7.0055835 C 7.2847685,7.1714586 8.242488,6.3893088 9.6844639,6.3893088 c 0.4418031,0 0.8454701,0.035977 1.1937321,0.1273602 V 5.5819749 A 4.7612557,4.7612557 0 0 0 9.6844639,5.4423824 c -2.1068389,0 -3.4682256,1.1289724 -3.7733144,3.0940606 H 5.1218042 V 9.2041845 H 5.8485487 V 10.114413 H 5.1218042 v 0.667742 z"
                  id="path2-4"
                />
              </svg>
              Abrechnung
            </b-button>
            <!-- HELP ICON  -->
            <b-button size="sm" variant="light" class="ml-2" href="https://www.bauvisor.de/auftraege/" target="_blank">
              <b-icon icon="question-circle" variant="dark"></b-icon>
            </b-button>
            <!-- X ICON -->
            <b-button class="ml-2 py-0" variant="light" @click="$router.go(-1)" size="sm">
              <b-icon icon="x" variant="dark" class="" style="height: 24px; width: 24px;padding-top:3px;"></b-icon>
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white px-4 mt-0 pt-0" style="border-bottom: 1px solid #dee2e6">
      <!----------------------------------------------------------
            S U M M A R Y   H E A D E R   -   R O W   1   |   Gesamtbudget, Nachtragsrückstellung, Status
      ----------------------------------------------------------->
      <div class="row pt-3 pb-0" style="max-width: 1000px">
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Gesamtbudget</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(parseFloat(order.BudgetSaldo), SettingsStore) }}
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Nachtragsrückstellung</small></label>
          <div class="bg-light p-1">
            {{
              $utils.numberWithMaxFrictionsDE(
                ((parseFloat(order.BudgetSaldo) -
                  (parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered))) /
                  parseFloat(order.BudgetSaldo)) *
                  100,
                1
              )
            }}
            %
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>&nbsp;</small></label>
          <div class="bg-light p-1">
            {{
              $utils.numberToCurrency(
                parseFloat(order.BudgetSaldo) - (parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered)),
                SettingsStore.settings['Centbetraege']
              )
            }}
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Status</small></label>
          <div class="bg-light p-1">{{ order.ProcessStatus }}</div>
        </div>
      </div>

      <div class="row mt-0 pb-4" style="max-width: 1000px">
        <div class="col col-3" v-show="SettingsStore.settings['KGR_Selections_Active'] == 'true'">
          <label class="text-muted d-block mb-1"><small>Kostengruppe</small></label>
          <div class="bg-light p-1">
            {{ order.KGR ? (order.KGR == '' ? '(leer)' : order.KGR) : '(leer)' }}
          </div>
        </div>
        <div class="col col-3" v-show="SettingsStore.settings['Responsible_Selections_Active'] == 'true'">
          <label class="text-muted d-block mb-1"><small>Verantwortlich</small></label>
          <div class="bg-light p-1">
            {{ order.Responsible ? (order.Responsible == '' ? '(leer)' : order.Responsible) : '(leer)' }}
          </div>
        </div>
        <div class="col col-3" v-show="SettingsStore.settings['FA1_Active'] == 'true'">
          <label class="text-muted d-block mb-1">
            <small>{{ SettingsStore.settings['FA1'] }}</small>
          </label>
          <div class="bg-light p-1">
            {{ order.FA1 ? (order.FA1 == '' ? '(leer)' : order.FA1) : '(leer)' }}
          </div>
        </div>
        <div class="col col-3" v-show="SettingsStore.settings['FA2_Active'] == 'true'">
          <label class="text-muted d-block mb-1">
            <small>{{ SettingsStore.settings['FA2'] }}</small>
          </label>
          <div class="bg-light p-1">
            {{ order.FA2 ? (order.FA2 == '' ? '(leer)' : order.FA2) : '(leer)' }}
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white px-4 mt-0 pt-0" style="border-bottom: 1px solid #dee2e6">
      <div class="row pt-3 pb-0" style="max-width: 1000px">
        <!----------------------------------------------------------
            S U M M A R Y   H E A D E R   -   R O W   2   |   Gesamtauftrag, Hauptauftrag, 
      ----------------------------------------------------------->
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Gesamtauftrag</small></label>
          <div class="bg-light p-1">
            {{
              $utils.formatCurrency(parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered), SettingsStore)
            }}
          </div>
        </div>
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Hauptauftrag</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.Amount, SettingsStore) }}
          </div>
        </div>
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Nachträge</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.AmountAddendumOrdered, SettingsStore) }}
          </div>
        </div>
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Restbudget für Nachträge</small></label>
          <div class="bg-light p-1">
            {{
              $utils.formatCurrency(
                parseFloat(order.BudgetSaldo) - (parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered)),
                SettingsStore
              )
            }}
          </div>
        </div>
      </div>
      <div class="row mt-0 pb-4" style="max-width: 1000px">
        <div class="col-3">
          <label class="text-muted d-block mb-1"><small>Auftragnehmer</small></label>
          <div class="bg-light p-1">
            {{ order.SupplierText }}
          </div>
        </div>
        <div class="col-6">
          <label class="text-muted d-block mb-1"><small>Auftragsstatus / Datum</small></label>
          <div class="bg-light p-1">
            {{ computeOrderStatus(order) }}
          </div>
        </div>
        <div class="col-3">
          <label class="text-muted d-block mb-1"><small>Nachträge in Prüfung</small></label>
          <div class="bg-light p-1">{{ $utils.formatCurrency(order.AmountAddendumChecking, SettingsStore) }}</div>
        </div>
      </div>
    </div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import OrdersService from '@/service/OrdersService';
import SettingsStore from '@/store/Settings';

export default {
  data() {
    return {
      order: {
        Ordinal: '',
        DisplayName: '',
        NTR: ''
      },
      isLoading: true,
      SettingsStore
    };
  },
  async activated() {
    await this.loadOrder();
    this.$eventBus.$on('update:nachtrag', () => this.loadOrder());
  },
  methods: {
    loadOrder() {
      OrdersService.getById(this.$route.params.id)
        .then(order => {
          this.order = order;
          if (!this.order.NTR) {
            this.order.NTR = parseFloat(SettingsStore.settings['Nachtragsprozent']).toFixed(2);
          }
          AppState.isLoading = false;
          this.isLoading = false;
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        });
    },
    computeOrderStatus(item) {
      if (item.veSection && item.veSection == 'A') {
        return (
          (item.VergabeEmpfehlung && item.VergabeEmpfehlung != '' ? item.VergabeEmpfehlung : 'Empfehlung') +
          ' / ' +
          this.$utils.SQLDateToGermanDate(item.VergabeEmpfehlungDatum)
        );
      } else if (item.veSection && item.veSection == 'B') {
        return (
          (item.OrderNumber && item.OrderNumber != '' ? item.OrderNumber : 'Bestellung') +
          ' / ' +
          this.$utils.SQLDateToGermanDate(item.OrderDate)
        );
      } else return '';
    }
  }
};
</script>
